import React, {useCallback, useEffect, useState} from 'react';
import {Dropdown} from "semantic-ui-react";
import './styles.scss';
import {apiPost} from "../../services/apiClient";
import uuidv4 from "uuid/v4";
import {toast} from "react-toastify";
import throttle from 'lodash.throttle';

const InputDropdown = (
    {
        className,
        name,
        nameOption,
        value,
        url,
        disabled,
        onChange,
        params,
        paramsForSearchFields,
        dependentFields,
        ignoredFields,
        searchErrorText,
        placeholder,
        error
    }
) => {
    const [options, setOptions] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [counter, setCounter] = useState(0);
    const [sessionKey] = useState(uuidv4());

    let controller;

    useEffect(() => {
        if (!options.length) setCounter(counter+1);
        else setCounter(0);
    }, [options]);

    useEffect(() => {
        if (counter === 5 && searchErrorText) {
            toast.error(searchErrorText);
            setCounter(0);
        }
    }, [counter]);

    const searchDataFunc = (text, setFirst) => {
        controller && controller.abort();
        controller = new AbortController();

        name = nameOption || name;

        const paramsData = {};

        paramsForSearchFields && paramsForSearchFields.forEach(p => {
            const nameParam = p[1] ? p[1] : p[0];
            paramsData[nameParam] = params[p[0]];
        })

        text && apiPost(url, {
            ...paramsData,
            text,
            sessionKey,
            maxCount: 10
        }, controller.signal).then(data => {
            setOptions(data.entries && data.entries.filter(e => e[name]).map((d, index) => ({
                value: d[name],
                key: d[name] + '_' + index,
                text: d[name],
                data: d,
            })));
            (setFirst && (data.entries || []).length) && onChangeValue(null, {value: data.entries[0][name]});
            controller = null;
        }).catch((e) => {
            console.log('Отмена запроса - ', e)
        })
    }

    const searchData = useCallback(throttle(searchDataFunc, 600), [params, paramsForSearchFields]);

    const onChangeValue = (e, {value}) => {
        const v = options.find(o => o.value === value);
        let values = {};
        if (v) {
            if (ignoredFields || !dependentFields) Object.keys(v.data).forEach(k => {
                if (!((ignoredFields || []).includes(k))) values[k] = v.data[k];
            });
            (dependentFields || []).forEach(f => values[f] = v.data[f] || null);
            onChange(name, value, values);
        }
    };

    useEffect(() => {
        setSearchQuery(value || '');
    }, [value]);

    useEffect(() => {
        (searchQuery && searchQuery !== '')
            ? searchData(searchQuery, value === searchQuery)
            : setOptions([]);
    }, [searchQuery]);

    return (
        <Dropdown
            error={error}
            className={`selection input-dropdown ${className || ''}`}
            placeholder={placeholder}
            fluid
            name={name}
            search={() => options}
            searchQuery={searchQuery}
            onSearchChange={(e, {searchQuery}) => {
                setSearchQuery(searchQuery);
                !searchQuery && onChange(name, null);
            }}
            disabled={disabled}
            options={options}
            value={value}
            noResultsMessage={'Не найдено'}
            onChange={onChangeValue}
            selectOnNavigation={false}
            selectOnBlur={false}
            onBlur={() => setSearchQuery(value || '')}
        />
    );
};

export default InputDropdown;


// WEBPACK FOOTER //
// ./App/components/Dropdowns/InputDropdown.jsx